import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "flowbite-react";

export default function AuctionRuleTemplateReadModal({
  open,
  onClose,
  template,
}) {
  return (
    <Modal show={open} onClose={onClose} size="4xl">
      <ModalHeader>{template?.title || "Rule Template"}</ModalHeader>

      <ModalBody>
        <div className="prose prose-sm dark:prose-invert max-w-none">
          <pre className="whitespace-pre-wrap text-sm leading-6">
            {template?.rules_text || "—"}
          </pre>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="gray" onClick={onClose}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}
